<template>
  <div class="execution">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        :key="tableKey"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="handleDel"
        @sort-change="sortChange"
        @selection-change="changeSelect"
        @search-change="searchChange"
      >
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-right: 20px;
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <!-- <el-button
              size="small"
              v-if="permissions['chain:projectinfo:excel']"
              :loading="tableLoading"
              style="margin-right: 20px; margin-bottom: 0"
              @click="exOut"
            >
              导出
            </el-button> -->
            <span class="reset" @click="reset"> 重置筛选条件 </span>
          </div>
        </template>
        <template slot="menuLeft" slot-scope="{ size }">
          <div class="menu-left">
            <div class="checked">
              <el-checkbox
                :value="multipleSelection.length > 0"
                @change="changeAll"
                style="margin-right: 8px"
              ></el-checkbox>
              已选<span> {{ multipleSelection.length }} </span>个
            </div>
            <el-button
              type="primary"
              style="margin-left: 6px"
              v-if="permissions['chain:companypayment2:askFor']"
              size="small"
              :disabled="multipleSelection.length < 1"
              @click="batchAskForInvoice"
            >
              批量索票</el-button
            >
          </div>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-button
            type="text"
            v-if="
              permissions['chain:companypayment2:askFor'] &&
              scope.row.invoiceStatus == 0 &&
              scope.row.paymentNo
            "
            size="small"
            plain
            @click="askForInvoice(scope.row, scope.index)"
          >
            索票</el-button
          >
          <!-- <el-button type="text"
                            v-if="permissions['chain:companypayment2:get']&&scope.row.isInvoice==1"
                            icon="el-icon-view"
                            size="small"
                            plain
                            @click="viewRow(scope.row,scope.index)">
                          查看</el-button> -->
        </template>
        <template slot="header" slot-scope="scope"> </template>
        <template slot="projectInfoId" slot-scope="scope">
          <span>{{ scope.row.projectName }}</span>
        </template>
        <!-- <template slot="settleCnt" slot-scope="scope">
                          <div style="color:#409eff;cursor:pointer" @click="settleDetail(scope.row)">1</div>
                        </template> -->
        <template slot="alreadyWaybillCount" slot-scope="scope">
          <span
            style="color: #409eff; cursor: pointer"
            @click="alreadyDetail(scope.row)"
            >{{ scope.row.alreadyWaybillCount }}</span
          >
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import {
  getInvoicePageList,
  getObj,
  addObj,
  putObj,
  delObj,
  askForInvoice,
  getPaymentOfInvoice,
  batchAdd,
} from "@/api/chain/companypayment";
import { getAllSettle } from "@/api/chain/createPayOrder";
import { tableOption } from "@/const/crud/chain/companypayment2";
import { mapGetters } from "vuex";

export default {
  name: "companypayment2",
  data() {
    return {
      tableKey:0,
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption,
      multipleSelection: [],
    };
  },
  created() {},
  mounted: function () {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:companypayment:add"] ? true : false,
        delBtn: this.permissions["chain:companypayment:del"] ? true : false,
        editBtn: this.permissions["chain:companypayment:edit"] ? true : false,
        viewBtn: this.permissions["chain:companypayment:get"] ? true : false,
      };
    },
  },
  methods: {
    updateTableHeight() {
        this.tableOption.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        this.tableKey += 1
    },
    changeAll(e) {
      if (e) {
        this.$refs.crud.$refs.table.toggleAllSelection();
      } else {
        this.multipleSelection = [];
        this.$refs.crud.$refs.table.clearSelection();
      }
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      getInvoicePageList(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done, loading) {
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    askForInvoice(row) {
      this.batchAdd({ companySettleId: row.companySettleId });
    },
    //批量索票
    batchAskForInvoice() {
      let companySettleId = this.multipleSelection
        .map((item) => {
          return item.companySettleId;
        })
        .join(",");
      console.log(companySettleId);
      let param = {
        companySettleId,
      };
      this.batchAdd(param);
    },
    batchAdd(param) {
      this.tableLoading = true;
      batchAdd(param)
        .then((res) => {
          this.tableLoading = false;
          this.$message.success("索票成功");
          this.getPage(this.page);
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    viewRow(row) {
      this.$ImagePreview(
        [{ thumbUrl: row.invoicePic, url: row.invoicePic }],
        0,
        {
          closeOnClickModal: true,
        }
      );
    },
    //查看结算单详情
    // settleDetail(row){
    //   this.tableLoading = true
    //   setTimeout(()=>{
    //     this.tableLoading = false
    //   },3000)
    //   getAllSettle(row.companyPaymentId).then(res=>{
    //     let settleDetailList = res.data.data
    //     this.tableLoading = false
    //     this.$router.push({path:'/waybill/waybillDetail',query:{value:JSON.stringify(settleDetailList)}})
    //     // params:JSON.stringify(this.settleDetailList)
    //     // this.settleDialog = true
    //   })
    // },
    //查看已开票
    alreadyDetail(row) {
      this.tableLoading = true;
      setTimeout(() => {
        this.tableLoading = false;
      }, 3000);
      let info = {
        list: [],
      };
      info.paymentNo = row.paymentNo;
      info.amt = row.amt;
      info.id = row.companySettleId;
      getPaymentOfInvoice(row.companySettleId).then((res) => {
        info.list = res.data.data;
        this.tableLoading = false;
        this.$router.push({
          path: "/companypayment/alreadyWaybill",
          query: { info: JSON.stringify(info) },
        });
      });
    },
    changeSelect(e) {
      this.multipleSelection = e;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
.menu-left {
  display: flex;
  align-items: center;
  /deep/.el-button {
    margin-bottom: 0;
  }
}
/deep/.avue-crud__menu{
  margin-bottom: 0;
}
/* 设置表格宽度占满父容器 */
/deep/.el-table {
  width: 100%;
  table-layout: auto;  /* 根据内容自动调整列宽 */
}

/* 设置表头文字换行，并确保文字显示完整 */
/deep/.el-table th .cell {
  white-space: normal;   /* 允许换行 */
  overflow: visible;     /* 内容不被隐藏 */
  text-overflow: unset;  /* 不使用省略号 */
}

/* 确保表格列宽根据内容自适应 */
/deep/.el-table td .cell {
  white-space: normal;   /* 允许内容换行 */
  overflow: visible;     /* 超出部分不隐藏 */
  text-overflow: unset;  /* 防止溢出文本被省略 */
}

</style>
